// 登録番号の検索処理の設定
export function setupInvoiceProvider()
{
    // インボイス情報
    $('.js-register_number').on('click', function(e) {
        var registre_number = $('input[name="register_number"]').val();
        $('#register-number-input-modal').find('input[name="md_register_number"]').val(registre_number);
        $('#register-number-input-modal').modal('show');
    });
    $('.js-register_number-find').on('click', function(e) {
        $(this).prop('disabled', true);
        findRegisterNumber();
    });
}

// 登録番号の検索、バリデーション
function findRegisterNumber() {
    var modal_input_form = $('#register-number-input-modal').find('input[name="md_register_number"]');
    var register_number = $('input[name="md_register_number"]').val();
    if (!register_number.match(/^\d*$/g) || (register_number.length > 0 && register_number.length != 13)) {
        modal_input_form.addClass('is-invalid');
        $('.js-register_number-error').text('登録番号は"T"を除く13桁の半角英数字で入力してください');
        $('.js-register_number-find').prop('disabled', false);
        return;
    }
    modal_input_form.removeClass('is-invalid');
    $('.js-register_number-error').text('');

    if (register_number.length > 0) {
        $.ajax({
            url: '/partner/invoiceProvider/find',
            type: 'POST',
            dataType : 'json',
            data: {
                'register_number': register_number,
            },
        }).done(function(data, textStatus, jqXHR) {
            $('.js-business_person_name').text(!data.business_person_name? '-': data.business_person_name);
            $('.js-place').text(!data.place_full? '-': data.place_full);
            let business_person_name = $('.js-bs-business_person_name').data('business_person_name');
            $('.js-bs-business_person_name').text(!data.business_person_name? business_person_name: data.business_person_name);
            let place_full = $('.js-bs-place').data('place_full');

            if (data.place_full) {
                $('.js-bs-place').text(data.place_full);
            } else if (data.business_person_name && !data.place_full) {
                // 名前有り住所無しの場合
                $('.js-bs-place').text('-');
            } else {
                $('.js-bs-place').text(place_full);
            }

            applyRegisterNumberStatus(data.status);
        }).fail(function(jqXHR, textStatus, errorThrown) {
            $('.js-business_person_name').text('-');
            $('.js-place').text('-');
            let business_person_name = $('.js-bs-business_person_name').data('business_person_name');
            $('.js-bs-business_person_name').text(business_person_name);
            let place_full = $('.js-bs-place').data('place_full');
            $('.js-bs-place').text(place_full);
            applyRegisterNumberStatus('unconfirmed');
        }).always(function() {
            applyRegisterNumber(register_number);
        });
    } else {
        applyRegisterNumber(register_number);
        $('.js-business_person_name').text('-');
        $('.js-place').text('-');
        let business_person_name = $('.js-bs-business_person_name').data('business_person_name');
        $('.js-bs-business_person_name').text(business_person_name);
        let place_full = $('.js-bs-place').data('place_full');
        $('.js-bs-place').text(place_full);
        applyRegisterNumberStatus('unregistered');
    }
}

// 登録番号をフォームに適用
function applyRegisterNumber(register_number) {
    $('input[name="register_number"]').val(register_number);
    $('#register-number-input-modal').modal('hide');
    $('.js-register_number-find').prop('disabled', false);
}

// 登録番号ステータスをフォームに適用
function applyRegisterNumberStatus(status) {
    var status_root = $('.js-register_number_status');
    var status_element = status_root.find('div');
    status_element.removeClass();
    var status_icon = status_element.find('i');
    status_icon.removeClass();
    var status_label = status_element.find('span');
    var error_label = $('.js-invoice_provider-error-label');
    switch (status) {
        case 'unregistered':
            status_root.hide();
            status_label.text('');
            error_label.text('')
            break;
        case 'valid':
            status_element.addClass('text-success');
            status_icon.addClass('fas fa-check-circle');
            status_label.text('有効');
            status_root.show();
            error_label.text('')
            break;
        case 'invalid':
            status_element.addClass('text-danger');
            status_icon.addClass('fas fa-exclamation-triangle');
            status_label.text('無効');
            status_root.show();
            error_label.text('※存在しない、または失効した番号です')
            break;
        case 'unconfirmed':
            status_element.addClass('text-danger');
            status_icon.addClass('fas fa-exclamation-triangle');
            status_label.text('未確認');
            status_root.show();
            error_label.text('※確認ができていない番号です')
            break;
    }
}
